import DodonesShow from 'app/dodones/Show'
import DodoablesShow from 'app/dodoables/Show'

const entityMap = {
  dodone: DodonesShow,
  dodoable: DodoablesShow
}

export default ({ entityName }) => {
  const { id } = useParams()
  const View = entityMap[entityName]
  const props = {}
  props[`${entityName}Id`] = id

  return <View {...props} />
}
